import { useEffect } from 'react'

import { getCurrentUser } from '@/selectors/user.selectors'
import { useReselector } from '@/utils/sharedHooks'
import { useAppDispatch } from '@/utils/typeHelpers'
import { fetchPayrollPrices } from './payrollActions'
import { selectPayrollPrices } from './payrollPrice.selectors'

export const usePayrollPrices = () => {
  const dispatch = useAppDispatch()
  const currentUser = useReselector(getCurrentUser)
  const shouldFetch = Boolean(currentUser?.id && !currentUser.admin)

  useEffect(() => {
    if (shouldFetch) {
      dispatch(fetchPayrollPrices())
    }
  }, [shouldFetch, dispatch])

  return useReselector(selectPayrollPrices)
}
